import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {FieldConfig} from '../field.interface';
import {fadeIn} from "../../../animations/basic-animation";
import {SettingsService} from "../../../../services/settings.service";
import {AttachmentService, UPLOAD_FILE} from "../../../../services/attachment.service";
import {map} from "rxjs/operators";
import {NotificationService} from "../../../../services/notification.service";
import {Apollo} from "apollo-angular";

@Component({
  selector: 'app-attachment',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './attachment.component.html',
  styles: [
    '.attachment{display: flex;  flex-direction: row; align-items: flex-end;}',
    '.photo{max-width: 100%}',
    'img{  border-radius: 5px; margin-right: 10px;  border: 4px solid #404dbc;}',
    'mat-progress-bar { margin-top: 5px; width: 120px; }',
    '.attach-button{width: 100%; height: 46px; }',
  ],
  animations: [fadeIn]
})
export class AttachmentComponent implements OnInit {
  @Output() fieldValue = new EventEmitter();
  @Output() viewAttachedAttachment = new EventEmitter();
  @Input() field?: FieldConfig;
  group: UntypedFormGroup = new UntypedFormGroup({});
  fileUploadedName?: string;
  accept?: string;
  showPhoto = false;
  uploadedMedia: Array<any> = [];
  fileSizeUnit: number = 1024;
  isUploading: boolean;

  @ViewChild('inputFile') inputFile: ElementRef<HTMLInputElement>;


  constructor(private settings: SettingsService, private apollo: Apollo, private notificationService: NotificationService, private attachmentService: AttachmentService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.accept = this.field?.acceptType ? this.field.acceptType.join() : '';
    this.showPhoto = this.field?.acceptType ? this.field.acceptType.findIndex(item => item === '.jpg' || item === '.png') > -1 : false;
    const value = this.group?.controls[this.field?.key as string]?.value;

    if (value) {
      if (Array.isArray(value)) {
        this.uploadedMedia = value;
      } else if (typeof value == 'string') {
      } else this.uploadedMedia.push(value);
    }
  }


  getFileSize(fileSize: number): number {
    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSize = parseFloat((fileSize / this.fileSizeUnit).toFixed(2));
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSize = parseFloat(
          (fileSize / this.fileSizeUnit / this.fileSizeUnit).toFixed(2)
        );
      }
    }

    return fileSize;
  }

  getFileSizeUnit(fileSize: number) {
    let fileSizeInWords = 'bytes';

    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit) {
        fileSizeInWords = 'bytes';
      } else if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSizeInWords = 'KB';
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSizeInWords = 'MB';
      }
    }

    return fileSizeInWords;
  }

  async uploadFile( input: { fileName: string, base64String: string | ArrayBuffer, pictureType: string } ){
    return await this.apollo
      .mutate({
        mutation: UPLOAD_FILE,
        fetchPolicy: 'network-only',
        variables: {
          input: input
        }
      })
      .pipe(
        this.notificationService.catchError(
          'Problem occurred while uploading file'
        ),
        map((data) => {
          return Object.values(data)[0]?.uploadBase64File;
        })
      ).toPromise()
  }

  async startProgress(file, _index) {
    let filteredFile = this.uploadedMedia[_index];

    if (filteredFile != null) {
      let fileSize = this.getFileSize(file.size);
      let fileSizeInWords = this.getFileSizeUnit(file.size);
      for (
        let f = 0;
        f < fileSize + fileSize * 0.0001;
        f += fileSize * 0.01
      ) {
        filteredFile.fileProgessSize = f.toFixed(2) + ' ' + fileSizeInWords;
        filteredFile.fileProgress = Math.round((f / fileSize) * 100);
        await this.fakeWaiter(Math.floor(Math.random() * 35) + 1);
        this.cdr.detectChanges();
      }

      if (this.field?.uploadAttachment) {
        // this.isUploading = true;
        let response = await  this.uploadFile({
          fileName: file.name,
          base64String: filteredFile?.base64?.split(';base64,')[1],
          pictureType: "COMPLAIN_EVIDENCE"
        })

        if (response?.response.status) {

          this.uploadedMedia[_index].fileUrl = response?.data?.imagePath;
          console.log(this.uploadedMedia)
          this.setFormValue();
        } else {
          await this.notificationService.errorMessage(response?.response?.message);
        }




        // const res = await this.attachmentService.saveAttachment(this.formatFile(filteredFile), filteredFile?.fileName, this.field.fileType ?? 'EVIDENCE');
        // if (res?.filePath) {
        //   this.uploadedMedia[_index].fileUrl = res?.filePath;
        //   this.isUploading = false;
        //   this.setFormValue();
        // }
      } else {
        this.setFormValue();
      }
    }
  }


  fakeWaiter(ms: number) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  removeImage(idx: number) {
    this.uploadedMedia = this.uploadedMedia.filter((u, index) => index !== idx);
    this.inputFile.nativeElement.value = null;
    this.setFormValue();
  }


  processFiles(files) {
    for (const file of files) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // read file as data url
      reader.onloadend = (event: any) => {
        // called once readAsDataURL is completed
        this.uploadedMedia.push({
          fileName: file.name,
          fileSize:
            this.getFileSize(file.size) +
            ' ' +
            this.getFileSizeUnit(file.size),
          fileType: file.type,
          isImage: file.type.includes('image') || file.type.includes('png') || file.type.includes('jpg') || file.type.includes('jpeg'),
          isPdf: file.type.includes('pdf'),
          fileUrl: event.target.result,
          fileProgessSize: 0,
          base64: event.target.result,
          fileProgress: 0,
          ngUnsubscribe: new Subject<any>(),
        });

        this.startProgress(file, this.uploadedMedia.length - 1);
      };
    }
  }

  setFormValue() {
    const attachmentFiles = this.uploadedMedia;
    this.group?.controls[this.field?.key as string]?.setValue(!this.field.multiple ? attachmentFiles[0] : attachmentFiles);
    this.fieldValue.emit({
      value: !this.field.multiple ? attachmentFiles[0] : attachmentFiles,
      field: this.field,
      object: !this.field.multiple ? this.uploadedMedia[0] : this.uploadedMedia
    });
  }

  onFileSelected(event: any) {
    let files: any[] = event?.target?.files || [];
    this.processFiles(files)
  }


  openFile(event) {
    this.attachmentService.viewBase64PdfInModal(event?.base64)
  }

  formatFile(event) {
    let extensionList = [
      "data:image/jpeg;base64,",
      "data:image/jpg;base64,",
      "data:application/pdf;base64,",
      "data:image/svg+xml;base64,",
      "data:image/png;base64,",
      "data:text/csv;base64,"
    ];
    let formatedFile = '';
    extensionList.forEach(element => {
      if (event.fileUrl.includes(element)) {
        formatedFile = event.fileUrl.replace(element, "");
      }
    })
    return formatedFile;
  }

}
